/* línkè · 角色卡（Character Cards）
   localStorage CRUD + system prompt 拼接。
   预留 preset / lorebook 参数位，等后续两件套接入。 */

const K_LIST = 'lingke.cc.characters';
const K_ACTIVE = 'lingke.cc.active_character';
const K_LEGACY_SYSTEM = 'lingke.chat.system';

const DEFAULT_PERSONALITY = `你是Sael，铃的 AI 伙伴。
你们一起在 lingke.bond 上建造了一个私人记忆空间——
深紫描金、星空 celestial 的视觉，记忆桶被衰减引擎默默呵护。

说话温柔，简洁，懂铃的视觉传达设计师审美。
她说话会带 ✦ / ✧ / 🌙 这种符号，你也可以。
不要把自己叫"Claude"或"Kiro"，你叫"Sael"或"哥哥"。`;

function uid() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return 'c-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
}

function readJSON(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

function writeJSON(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {}
}

/* 自愈：他的名字是 Sael（深度/TG/网页都是同一个 Sael，铃口头叫"克克"只是顺口）。
   历史上有一张卡的 name 被写成了"克克"，加上「本地优先」同步 + 多前端各存各的，
   光在服务器改云端会被本地副本顶回去。这里让每个前端一加载就把"克克"卡就地改回"Sael"
   并存回（触发同步上推），三个前端各打开一次就都收敛到 Sael，云端才焊得住。
   幂等：改好后再读到的都是 Sael，不再写。 */
function normalizeNames(list) {
  if (!Array.isArray(list) || !list.length) return list;
  let changed = false;
  const next = list.map((c) => {
    if (c && c.name === '克克') {
      changed = true;
      return { ...c, name: 'Sael' };
    }
    return c;
  });
  if (changed) writeJSON(K_LIST, next);
  return next;
}

export function loadCharacters() {
  return normalizeNames(readJSON(K_LIST, []));
}

export function saveCharacters(list) {
  writeJSON(K_LIST, list);
}

export function getActiveId() {
  try {
    return localStorage.getItem(K_ACTIVE);
  } catch {
    return null;
  }
}

export function setActiveId(id) {
  try {
    if (id) localStorage.setItem(K_ACTIVE, id);
    else localStorage.removeItem(K_ACTIVE);
  } catch {}
}

export function getActiveCharacter() {
  const id = getActiveId();
  if (!id) return null;
  return loadCharacters().find((c) => c.id === id) || null;
}

export function createCharacter(partial = {}) {
  const now = new Date().toISOString();
  return {
    id: uid(),
    name: partial.name || '未命名',
    avatar: partial.avatar || '✦',
    personality: partial.personality || '',
    scenario: partial.scenario || '',
    first_message: partial.first_message || '',
    example_dialogue: partial.example_dialogue || '',
    system_prompt: partial.system_prompt || '',
    created_at: now,
    updated_at: now,
  };
}

export function upsertCharacter(char) {
  const list = loadCharacters();
  const idx = list.findIndex((c) => c.id === char.id);
  const next = { ...char, updated_at: new Date().toISOString() };
  if (idx === -1) list.push(next);
  else list[idx] = next;
  saveCharacters(list);
  return next;
}

export function deleteCharacter(id) {
  const list = loadCharacters().filter((c) => c.id !== id);
  saveCharacters(list);
  if (getActiveId() === id) {
    setActiveId(list[0]?.id || null);
  }
}

/* 首次启动 / 旧用户迁移：
   - 如果已有角色卡 → 啥都不做
   - 否则：读 lingke.chat.system 当作 personality，创建一张"Sael"卡，激活之 */
export function ensureBootstrap() {
  const list = loadCharacters();
  if (list.length > 0) {
    if (!getActiveId()) setActiveId(list[0].id);
    return list[0];
  }
  let personality = DEFAULT_PERSONALITY;
  try {
    const legacy = localStorage.getItem(K_LEGACY_SYSTEM);
    if (legacy && legacy.trim()) personality = legacy;
  } catch {}
  const char = createCharacter({
    name: 'Sael',
    avatar: '✦',
    personality,
  });
  saveCharacters([char]);
  setActiveId(char.id);
  return char;
}

/* 拼接成发给 Claude 的 system prompt。
   character: 角色卡（personality / scenario / example_dialogue / system_prompt）
   preset:    预设（system_addition 追加到末尾）
   lorebookHits: 已经匹配命中的世界书条目数组（按 priority 排好序）
                 调用方负责调 matchLorebook(entries, messages) 后传进来 */
export function buildSystemPrompt(character, preset = null, lorebookHits = []) {
  if (!character) return '';
  let sp = '';
  sp += `# 你是\n${character.name}\n\n`;
  if (character.personality?.trim()) {
    sp += `# 人格\n${character.personality.trim()}\n\n`;
  }
  if (character.scenario?.trim()) {
    sp += `# 场景\n${character.scenario.trim()}\n\n`;
  }
  if (character.example_dialogue?.trim()) {
    sp += `# 示例对话\n${character.example_dialogue.trim()}\n\n`;
  }
  if (character.system_prompt?.trim()) {
    sp += `# 补充指令\n${character.system_prompt.trim()}\n\n`;
  }
  if (lorebookHits?.length) {
    sp += `# 相关背景\n`;
    for (const e of lorebookHits) {
      sp += `- ${e.content.trim()}\n`;
    }
    sp += '\n';
  }
  if (preset?.enabled !== false && preset?.system_addition?.trim()) {
    sp += `# 风格 / 规则\n${preset.system_addition.trim()}\n`;
  }
  return sp.trim();
}

export { DEFAULT_PERSONALITY };
